import * as React from 'react'
import { Link } from 'react-router-dom'
import { debounce } from 'throttle-debounce'
import RidersTable from '../../containers/riders/RidersTable'
import UIMessages from '../../utils/ui-messages'
import FindIcon from '../icons/ui/Find'
import HorizontalSelector from '../HorizontalSelector'
import HorizontalSelectorItem from '../HorizontalSelectorItem'
import RiderJoinRequestTable from '../../containers/riders/RiderJoinRequestTable'
import { IRiderFilters } from '../../types'
import { History } from 'history'
import { Button, Input } from '@mobiscroll/react-latest'
import '@mobiscroll/react-latest/dist/css/mobiscroll.min.css'

interface IRidersTablePaneProps {
  currentOrgId: string
  history: History
}

interface IRidersTablePaneState {
  filters: IRiderFilters
  searchValue: string | undefined
}

class RidersTablePane extends React.Component<IRidersTablePaneProps, IRidersTablePaneState> {
  public state: IRidersTablePaneState = {
    filters: {
      isFirstArchived: true,
      isSecondArchived: false,
      isThirdArchived: false,
      search: '',
      orgId: this.props.currentOrgId
    },
    searchValue: ''
  }

  public searchRidersDebounced = debounce(500, (search: string) => {
    this.setState({ filters: { ...this.state.filters, search } })
  })

  public componentDidUpdate(prevProps: IRidersTablePaneProps) {
    if (this.props.currentOrgId !== prevProps.currentOrgId) {
      this.setState({ filters: { ...this.state.filters, orgId: this.props.currentOrgId } })
    }
  }

  public render() {
    const { filters } = this.state
    const { isFirstArchived, isSecondArchived, isThirdArchived } = filters

    const ROUTES = {
      CREATE_RIDER: '/riders/create/profile'
    } as const

    const createRider = () => {
      this.props.history.push(ROUTES.CREATE_RIDER)
    }

    return (
      <div className='pt2'>
        <div className='flex mb2 items-center'>
          <div className='ml2'>
            <HorizontalSelector>
              <HorizontalSelectorItem isSelected={filters.isFirstArchived}>
                <div className='uppercase cursor--pointer' onClick={this.setArchived('First-Menu')}>
                  {UIMessages.common.ridersList}
                </div>
              </HorizontalSelectorItem>
              <HorizontalSelectorItem isSelected={filters.isSecondArchived}>
                <div className='uppercase cursor--pointer' onClick={this.setArchived('Sec-Menu')}>
                  {UIMessages.common.joinRequest}
                </div>
              </HorizontalSelectorItem>
              <HorizontalSelectorItem isSelected={filters.isThirdArchived}>
                <div className='uppercase cursor--pointer' onClick={this.setArchived('Third-Menu')}>
                  {UIMessages.common.archivedRiders}
                </div>
              </HorizontalSelectorItem>
            </HorizontalSelector>
          </div>
          <div style={{ flex: 1 }}>&nbsp;</div>
          <div className='flex items-center mr3'>
            <Input
              className='RidersSearchInput mr1 mobiscroll-input'
              type='text'
              onChange={this.searchRiders}
              value={this.state.searchValue}
              theme='ios'
              themeVariant='light'
              inputStyle='box'
              labelStyle='floating'
              placeholder={UIMessages.common.search}
            />
            <FindIcon className='svg-stroke-grey3' />
          </div>
          <Button className='mobiscroll-green-btn' onClick={createRider}>
            <span className='font-white'>+ {UIMessages.common.createNewRider}</span>
          </Button>
        </div>
        <div>
          {isFirstArchived === true && isSecondArchived === false && isThirdArchived === false ? (
            <RidersTable filters={filters} />
          ) : (
            ''
          )}
          {isSecondArchived ? <RiderJoinRequestTable filters={filters} /> : ''}
          {isFirstArchived === false && isSecondArchived === false && isThirdArchived === true ? (
            <RidersTable filters={filters} />
          ) : (
            ''
          )}
          {/* uncomment line below later when working on join request issue */}
          {/* {isThirdArchived ? <RidersTable filters={filters} /> : ''} */}
        </div>
      </div>
    )
  }

  private searchRiders = (e: any) => {
    const regex = /[\\\/\$\|\&\%\#\.\?]/g
    const search = e && e.target.value ? e.target.value.replaceAll(regex, '') : undefined
    this.setState({ searchValue: search })
    this.searchRidersDebounced(search)
  }

  private setArchived = (isArchived: string) => {
    if (isArchived === 'First-Menu') {
      return (e: any) => {
        this.setState({
          filters: {
            ...this.state.filters,
            isArchived: false,
            isFirstArchived: true,
            isSecondArchived: false,
            isThirdArchived: false
          }
        })
      }
    } else if (isArchived === 'Sec-Menu') {
      return (e: any) => {
        this.setState({
          filters: {
            ...this.state.filters,
            isFirstArchived: false,
            isSecondArchived: true,
            isThirdArchived: false
          }
        })
      }
    } else {
      return (e: any) => {
        this.setState({
          filters: {
            ...this.state.filters,
            isArchived: true,
            isFirstArchived: false,
            isSecondArchived: false,
            isThirdArchived: true
          }
        })
      }
    }
  }
}

export default RidersTablePane



// WEBPACK FOOTER //
// ./src/components/riders/RidersTablePane.tsx